import { MouseEventHandler } from 'react';
import { useParams } from 'react-router-dom';
import { QuestionOverviewType } from '../../../api/student-question';
import toast from 'react-hot-toast';
import { DEFAULT_LOADER_CONTENT } from '../../shared/loader';
import { useUpdateStudentQuestionOptionMutation } from '../../../hooks/react-query/use-student-question';
import classNames from 'classnames';

export type QuestionContentPropsType = {
  question: QuestionOverviewType;
  studentQuestionId: number;
  selectedOptionId: number | null;
};

function QuestionContent({
  question,
  studentQuestionId,
  selectedOptionId
}: QuestionContentPropsType) {
  const { mutateAsync: updateStudentQuestionOption } = useUpdateStudentQuestionOptionMutation();
  const { questionNumber } = useParams();

  const handleClick: MouseEventHandler<HTMLInputElement> = async e => {
    const clickedOptionId = parseInt(e.currentTarget.value);
    const optionId = clickedOptionId === selectedOptionId ? null : clickedOptionId;

    await toast.promise(
      updateStudentQuestionOption({
        studentQuestionId,
        optionId,
        questionNumber: parseInt(questionNumber as string)
      }),
      {
        loading: DEFAULT_LOADER_CONTENT,
        success: (
          <b>
            {optionId ? 'گزینه انتخاب شده با موفقیت ثبت گردید.' : 'حذف گزینه با موفقیت ثبت گردید.'}
          </b>
        ),
        error: <b className='text-red-500'>عدم موفقیت</b>
      }
    );
  };

  return (
    <form data-testid='option-form' className='grid grid-cols-1 gap-5 py-3'>
      <div dangerouslySetInnerHTML={{ __html: question.question }} className='ck-content' />
      <div className='my-2'>
        {question.options.map(option => {
          return (
            <div key={option.id} className='align-center flex py-1'>
              <input
                type='radio'
                id={`option-${option.id}`}
                name='option'
                value={option.id}
                checked={option.id === selectedOptionId}
                onChange={() => null}
                onClick={handleClick}
              />
              <label
                htmlFor={`option-${option.id}`}
                className={classNames('mx-2', {
                  'text-lg font-medium': option.id === selectedOptionId
                })}
              >
                {option.text.startsWith('<') ? (
                  <div dangerouslySetInnerHTML={{ __html: option.text }} className='ck-content' />
                ) : (
                  <div>{option.text}</div>
                )}
              </label>
            </div>
          );
        })}
      </div>
    </form>
  );
}

export default QuestionContent;
